import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import i18n from "@/i18n";

const statusConfig: Record<string, { labelKey: string; classes: string }> = {
  pending: { labelKey: "orderStatusBadge.status.pending", classes: "bg-primary/5 text-primary border-primary/20 dark:bg-primary/10 dark:text-primary dark:border-primary/20" },
  processing: { labelKey: "orderStatusBadge.status.processing", classes: "bg-blue-50 text-blue-700 border-blue-200/50 dark:bg-blue-900/20 dark:text-blue-400 dark:border-blue-800/30" },
  paid: { labelKey: "orderStatusBadge.status.paid", classes: "bg-secondary text-secondary-foreground border-border/50" },
  approved: { labelKey: "orderStatusBadge.status.approved", classes: "bg-secondary text-secondary-foreground border-border/50" },
  free_approved: { labelKey: "orderStatusBadge.status.freeApproved", classes: "bg-secondary text-secondary-foreground border-border/50" },
  cancelled: { labelKey: "orderStatusBadge.status.cancelled", classes: "bg-red-50 text-red-700 border-red-200/50 dark:bg-red-900/20 dark:text-red-400 dark:border-red-800/30" },
  refunded: { labelKey: "orderStatusBadge.status.refunded", classes: "bg-purple-50 text-purple-700 border-purple-200/50 dark:bg-purple-900/20 dark:text-purple-400 dark:border-purple-800/30" },
  expired: { labelKey: "orderStatusBadge.status.expired", classes: "bg-slate-50 text-slate-700 border-slate-200/50 dark:bg-slate-900/20 dark:text-slate-400 dark:border-slate-800/30" },
  // Boleto vencido: cobrança em aberto e ingresso válido — âmbar (ação pendente),
  // não cinza de "expired", que significa reserva morta.
  overdue: { labelKey: "orderStatusBadge.status.overdue", classes: "bg-amber-50 text-amber-700 border-amber-200/50 dark:bg-amber-900/20 dark:text-amber-400 dark:border-amber-800/30" },
  active: { labelKey: "orderStatusBadge.status.active", classes: "bg-secondary text-secondary-foreground border-border/50" },
  used: { labelKey: "orderStatusBadge.status.used", classes: "bg-indigo-50 text-indigo-700 border-indigo-200/50 dark:bg-indigo-900/20 dark:text-indigo-400 dark:border-indigo-800/30" },
  transferred: { labelKey: "orderStatusBadge.status.transferred", classes: "bg-slate-50 text-slate-700 border-slate-200/50 dark:bg-slate-900/20 dark:text-slate-400 dark:border-slate-800/30" },
  boleto_pending: { labelKey: "orderStatusBadge.status.boletoPending", classes: "bg-primary/5 text-primary border-primary/20 dark:bg-primary/10 dark:text-primary dark:border-primary/20" },
};

function resolveStatusKey(status: string, paymentMethod?: string, total?: number): string {
  if (status === "paid" && (paymentMethod === "free" || total === 0)) {
    return "free_approved";
  }
  return status;
}

export function getOrderStatusLabel(status: string, paymentMethod?: string, total?: number): string {
  const key = resolveStatusKey(status, paymentMethod, total);
  const entry = statusConfig[key];
  return entry ? i18n.t(entry.labelKey, { ns: "producerCommon" }) : status;
}

export function OrderStatusBadge({
  status,
  paymentMethod,
  total,
  className,
}: {
  status: string;
  paymentMethod?: string;
  total?: number;
  className?: string;
}) {
  const { t } = useTranslation("producerCommon");
  const key = resolveStatusKey(status, paymentMethod, total);
  const entry = statusConfig[key];
  const label = entry ? t(entry.labelKey) : key;
  const classes = entry?.classes || "bg-muted text-muted-foreground border-border";
  return (
    <span className={cn("inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-full border", classes, className)}>
      {label}
    </span>
  );
}
